import { render, staticRenderFns } from "./UserSelector.vue?vue&type=template&id=4ed7d062&scoped=true&"
import script from "./UserSelector.vue?vue&type=script&lang=js&"
export * from "./UserSelector.vue?vue&type=script&lang=js&"
import style0 from "./UserSelector.vue?vue&type=style&index=0&id=4ed7d062&lang=scss&scoped=true&"
import style1 from "./UserSelector.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed7d062",
  null
  
)

export default component.exports